export const alphabetsData = [
    { letter: 'A', word: 'Apple', emoji: '🍎', color: '#FF6B6B' },
    { letter: 'B', word: 'Ball', emoji: '⚽', color: '#4ECDC4' },
    { letter: 'C', word: 'Cat', emoji: '🐱', color: '#FFE66D' },
    { letter: 'D', word: 'Dog', emoji: '🐶', color: '#1A535C' },
    { letter: 'E', word: 'Elephant', emoji: '🐘', color: '#FF9F1C' },
    { letter: 'F', word: 'Fish', emoji: '🐟', color: '#2EC4B6' },
    { letter: 'G', word: 'Grapes', emoji: '🍇', color: '#9B5DE5' },
    { letter: 'H', word: 'House', emoji: '🏠', color: '#F15BB5' },
    { letter: 'I', word: 'Ice Cream', emoji: '🍦', color: '#FEE440' },
    { letter: 'J', word: 'Juice', emoji: '🧃', color: '#00BBF9' },
    { letter: 'K', word: 'Kite', emoji: '🪁', color: '#00F5D4' },
    { letter: 'L', word: 'Lion', emoji: '🦁', color: '#FF6B6B' },
    { letter: 'M', word: 'Monkey', emoji: '🐵', color: '#4ECDC4' },
    { letter: 'N', word: 'Nest', emoji: '🪺', color: '#FFE66D' },
    { letter: 'O', word: 'Orange', emoji: '🍊', color: '#FF9F1C' },
    { letter: 'P', word: 'Penguin', emoji: '🐧', color: '#1A535C' },
    { letter: 'Q', word: 'Queen', emoji: '👑', color: '#9B5DE5' },
    { letter: 'R', word: 'Rainbow', emoji: '🌈', color: '#F15BB5' },
    { letter: 'S', word: 'Star', emoji: '⭐', color: '#FEE440' },
    { letter: 'T', word: 'Tiger', emoji: '🐯', color: '#FF6B6B' },
    { letter: 'U', word: 'Umbrella', emoji: '☂️', color: '#4ECDC4' },
    { letter: 'V', word: 'Violin', emoji: '🎻', color: '#FFE66D' },
    { letter: 'W', word: 'Whale', emoji: '🐳', color: '#00BBF9' },
    { letter: 'X', word: 'Xylophone', emoji: '🎹', color: '#FF9F1C' },
    { letter: 'Y', word: 'Yak', emoji: '🐂', color: '#1A535C' },
    { letter: 'Z', word: 'Zebra', emoji: '🦓', color: '#2EC4B6' }
];
